import styled from 'styled-components';

const SimpleSubMenuContainer = styled.div`
  @media (min-width: 1240px) {
    background: var(--white-color);
    border: 1px solid #e9eff2;
    box-shadow: 0px 4px 10px rgba(0, 0, 0, 0.08);
    box-sizing: border-box;
    position: absolute;
    padding: 0;
    transition: opacity 0.1s;
    z-index: 2147483647 !important;
    max-width: 400px;
    visibility: hidden;
    opacity: 0;
    margin-top: -20px;
    transition: all 0.25s ease-out;
    pointer-events: none;
    transform: translateX(-50%);
    margin-left: 50px;
  }
`;

export { SimpleSubMenuContainer };
